module.exports = __webpack_public_path__ + "img/score-icon.1e9d8dc.png";